var _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.09467 3.09467C4.42914 1.7602 6.42603 1.25 9 1.25H15C17.574 1.25 19.5709 1.7602 20.9053 3.09467C22.2398 4.42914 22.75 6.42603 22.75 9V15C22.75 17.574 22.2398 19.5709 20.9053 20.9053C19.5709 22.2398 17.574 22.75 15 22.75H9C6.42603 22.75 4.42914 22.2398 3.09467 20.9053C1.7602 19.5709 1.25 17.574 1.25 15V9C1.25 6.42603 1.7602 4.42914 3.09467 3.09467ZM4.15533 4.15533C3.2398 5.07086 2.75 6.57397 2.75 9V15C2.75 17.426 3.2398 18.9291 4.15533 19.8447C5.07086 20.7602 6.57397 21.25 9 21.25H15C17.426 21.25 18.9291 20.7602 19.8447 19.8447C20.7602 18.9291 21.25 17.426 21.25 15V9C21.25 6.57397 20.7602 5.07086 19.8447 4.15533C18.9291 3.2398 17.426 2.75 15 2.75H9C6.57397 2.75 5.07086 3.2398 4.15533 4.15533Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.77 7.10999C1.77 6.69577 2.10579 6.35999 2.52 6.35999H21.48C21.8942 6.35999 22.23 6.69577 22.23 7.10999C22.23 7.5242 21.8942 7.85999 21.48 7.85999H2.52C2.10579 7.85999 1.77 7.5242 1.77 7.10999Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.52 1.35999C8.93422 1.35999 9.27 1.69577 9.27 2.10999V6.96999C9.27 7.3842 8.93422 7.71999 8.52 7.71999C8.10579 7.71999 7.77 7.3842 7.77 6.96999V2.10999C7.77 1.69577 8.10579 1.35999 8.52 1.35999Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.48 1.35999C15.8942 1.35999 16.23 1.69577 16.23 2.10999V6.51999C16.23 6.9342 15.8942 7.26999 15.48 7.26999C15.0658 7.26999 14.73 6.9342 14.73 6.51999V2.10999C14.73 1.69577 15.0658 1.35999 15.48 1.35999Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8367 12.333C10.7098 12.4064 10.5 12.6402 10.5 13.25V15.65C10.5 16.2598 10.7098 16.4936 10.8367 16.567C10.9631 16.6401 11.2687 16.7052 11.7942 16.4009L13.8742 15.2009C13.8741 15.201 13.8744 15.2009 13.8742 15.2009C14.3993 14.8968 14.4975 14.5982 14.4975 14.45C14.4975 14.3018 14.3997 14.0035 13.8747 13.6993C13.8745 13.6993 13.8748 13.6994 13.8747 13.6993L11.7942 12.4991C11.2687 12.1948 10.9631 12.2599 10.8367 12.333ZM12.5453 11.2006C11.7409 10.7351 10.8367 10.6002 10.0858 11.0345C9.33519 11.4686 9 12.3198 9 13.25V15.65C9 16.5802 9.33519 17.4314 10.0858 17.8655C10.8367 18.2998 11.741 18.1649 12.5453 17.6994C12.5451 17.6994 12.5455 17.6993 12.5453 17.6994L14.6258 16.4991C15.4303 16.0333 15.9975 15.3168 15.9975 14.45C15.9975 13.5833 15.4303 12.8667 14.6258 12.4009L13.5848 11.8004L12.5453 11.2006C12.5454 11.2007 12.5451 11.2005 12.5453 11.2006Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewVideo);
export default __webpack_public_path__ + "static/media/newVideo.9ad5059e.svg";
export { ForwardRef as ReactComponent };